<template>
  <div>
    <v-dialog
      v-model="dialog"
      max-width="400px"
      @keydown.esc="close()"
    >
      <template v-slot:activator="{ on, attrs }">
        <div
          v-bind="attrs"
          v-on="on"
        >
          <slot>
            {{ label }}
          </slot>
        </div>
      </template>
      <v-card>
        <v-form
          id="form_change_password"
          ref="form"
          v-model="isValid"
          lazy-validation
        >
          <v-card-title>
            <span class="headline">{{ label }}</span>
            <v-spacer />
            <v-btn
              icon
              @click="close()"
            >
              <v-icon color="error">
                mdi-close
              </v-icon>
            </v-btn>
          </v-card-title>
          <v-divider />
          <v-card-text>
            <v-container class="px-0">
              <v-row no-gutters>
                <v-col
                  v-if="!resetPassword"
                  cols="12"
                >
                  <v-text-field
                    id="fld_current_password"
                    v-model="password.currentPassword"
                    type="password"
                    label="Current Password*"
                    :rules="currentPasswordRules"
                    autofocus
                    required
                    :error-messages="getError('CurrentPassword')"
                    outlined
                    dense
                    @mouseup="dirtyError('CurrentPassword')"
                  />
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    id="fld_new_password"
                    v-model="password.newPassword"
                    type="password"
                    label="New Password*"
                    :rules="NewPasswordRules"
                    required
                    :error-messages="getError('NewPassword')"
                    outlined
                    dense
                    @mouseup="dirtyError('NewPassword')"
                  />
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    id="fld_confirm_password"
                    v-model="password.confirmPassword"
                    type="password"
                    label="Confirm Password*"
                    :rules="confirmPasswordRules"
                    required
                    :error-messages="getError('ConfirmPassword')"
                    outlined
                    dense
                    @mouseup="dirtyError('ConfirmPassword')"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <div class="font-weight-bold text-uppercase">
                    Password rules
                  </div>
                  <ul>
                    <li>*indicates required field.</li>
                    <li>New Password should be 6 - 15 characters.</li>
                    <li>New Password should contain minimum one UpperCase.</li>
                    <li>New Password should contain minimum one Special.</li>
                    <li>New Password should contain minimum one Number.</li>
                  </ul>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-divider />
          <v-card-actions>
            <v-spacer />
            <v-btn
              id="change_password_close"
              color="error"
              class="white--text"
              style="position: relative"
              @click.native="close()"
            >
              Close
            </v-btn>

            <v-btn
              id="change_password_save"
              color="success"
              :disabled="!isValid"
              :loading="submitLoader"
              @click.native="changePassword(password)"
            >
              Update
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "ChangePassword",
  props: {
    resetPassword: {
      type: Boolean, 
      default: false
    },
    userId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      label: "Change Password",
      dialog: false,
      submitLoader: false,
      isValid: false,
      password: {},
      errors: {},
      currentPasswordRules: [(v) => !!v || "Current password is required"],
      NewPasswordRules: [(v) => !!v || "New password is required"],
      confirmPasswordRules: [(v) => !!v || "Confirm password is required"]
    };
  },
  watch: {
    dialog:{
      immediate: true,
      handler(val) {
        if (this.resetPassword) {
          this.label = "Reset Password";
        }
        if (val) {
          this.reset();
        }
      }
    }
  },
  methods: {
    changePassword (item) {
      if (!this.$refs.form.validate()) {
        return;
      }
      this.submitLoader = true;

      let url;
      if (this.resetPassword){
        url = `${this.ADMIN_API_URL}/users/${this.userId}/resetPassword`;
      } else {
        url = `${this.ADMIN_API_URL}/changePassword`;
      }

      this.$http.put(url, item).then(
        (response) => {
          console.log({ response });
          this.handleSuccess(response.body);
        },
        (failure) => {
          this.handleFailure(failure);
        }
      );
    },
    handleSuccess (response) {
      this.submitLoader = false;
      this.$store.commit("showSnackbar", {
        timeout: 3000,
        message: response.message
      });
      this.close();
    },
    handleFailure (failure) {
      this.submitLoader = false;
      let msg = failure.body.message || "invalid request";
      let errors = failure.body.errors;
      this.errors = errors;
      if (errors && errors.CurrentPassword) {
        msg = errors.CurrentPassword;
      }
      if (errors && errors.NewPassword) {
        msg = errors.newPassword;
      }

      if (errors && errors.ConfirmPassword) {
        msg = errors.confirmPassword;
      }

      this.$store.commit("showSnackbar", {
        message: msg,
        color: "error"
      });
    },
    reset() {
      this.errors = {};
      if (this.$refs.form) {
        this.$refs.form.reset();
      }
    },
    close () {
      this.dialog = false;
      this.reset();
    },
    getError(key) {
      return this.errors && this.errors[key] ? this.errors[key] : [];
    },
    dirtyError(key) {
      this.errors[key] = "";
    }
  }
};
</script>